export default __webpack_public_path__ + "assets/424f77.svg";